import React from 'react';
import { TextField, } from '@mui/material';
// locals
import EndAdornment from './EndAdornment';
export default function AutocompleteTextField({ TextFieldProps, inputBoxVal, params, showHelp, setInputValue, setCurrentSearch, }) {
    const { helperText, InputProps = {} } = TextFieldProps;
    return (React.createElement(TextField, { onBlur: () => 
        // this is used to restore a refName or the non-user-typed input
        // to the box on blurring
        setInputValue(inputBoxVal), ...params, ...TextFieldProps, size: "small", helperText: helperText, InputProps: {
            ...params.InputProps,
            ...InputProps,
            endAdornment: (React.createElement(EndAdornment, { showHelp: showHelp, endAdornment: params.InputProps.endAdornment })),
        }, placeholder: "Search for location", onChange: e => setCurrentSearch(e.target.value) }));
}
